module.exports = __webpack_public_path__ + "static/media/title_bg_3.7b3f104b.png";